import { HospitalNotifyConstants } from '../store/hospitalNotify.constants'

// TODO: Add this line to src\features\validation\schemas\index.ts
// export { hospitalNotifySchemas } from '../../hospitalNotify/validation/hospitalNotify.schema'

export const hospitalNotifySchemas = [
  {
    inputKey: HospitalNotifyConstants.SET_METHOD,
    isNumber: false,
    type: 'object',
    properties: {
      SET_METHOD: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_METHOD'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_METHOD: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: HospitalNotifyConstants.SET_ALERT_TYPE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ALERT_TYPE: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ALERT_TYPE'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_ALERT_TYPE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: HospitalNotifyConstants.SET_POTENTIAL_REGISTRY,
    isNumber: true,
    type: 'object',
    properties: {
      SET_POTENTIAL_REGISTRY: {
        type: 'number',
        // ToDo: confirm Pattern/ Min/ Max is set correctly
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_POTENTIAL_REGISTRY'],
  },
  {
    inputKey: HospitalNotifyConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: HospitalNotifyConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const hospitalNotifySecondsSchemas = [
  {
    inputKey: HospitalNotifyConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
